import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { environment } from '../../../environment';

export class TranslationsLoader implements TranslateLoader {
  constructor(public http: HttpClient) {}

  getTranslation() {
    const navigatorLanguage = navigator.language;
    const languageToUse = (navigatorLanguage.indexOf('-') !== -1) ? navigatorLanguage : `${navigatorLanguage}-${navigatorLanguage}`;

    return this.http.get(
      environment.endpoints.translations,
      {
        headers: new HttpHeaders()
          .set('language', languageToUse),
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/loaders/translations-loader.ts